function handleScroll(): void {
  const mvSection = document.getElementById("mv-section");
  const scrollSections = document.querySelectorAll(".js-scroll-section");
  const mvImage = mvSection?.querySelector(".mv-image-container") || null;
  // const mvText = mvSection?.querySelector(".mv-text-container") || null;

  if (mvSection) {
    const mvRect = mvSection.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    animateSection(mvRect, windowHeight, mvImage, true);

    scrollSections.forEach((scrollSection) => {
      const scrollImage = scrollSection.querySelector(".section-image-container") || null;
      // const scrollText = scrollSection.querySelector(".section-text-container") || null;
      const scrollRect = scrollSection.getBoundingClientRect();
      animateSection(scrollRect, windowHeight, scrollImage, false);
    });
  }
  window.addEventListener("scroll", handleScroll);
}

function animateSection(
  rect: DOMRect,
  windowHeight: number,
  image: Element | null,
  // text: Element | null,
  isMVSection: boolean,
): void {
  const progress = isMVSection
    ? 1 - Math.max(0, rect.bottom / windowHeight)
    : Math.max(0, Math.min(1, 1 - rect.top / (windowHeight / 2)));

  if (image) {
    const htmlImage = image as HTMLElement;
    const isWideScreen = window.innerWidth >= 768;

    if (isMVSection) {
      if (isWideScreen) {
        // 画面幅が768以上のisMVSectionの場合の処理
        htmlImage.style.opacity = (2 - progress * 2).toString();
        htmlImage.style.transform = `scale(min(1, ${(0.85 + progress * 0.2).toString()}))`;
      } else {
        // 画面幅が767以下のisMVSectionの場合の処理
        htmlImage.style.opacity = (1 - progress).toString();
        htmlImage.style.transform = `scale(min(1, ${(0.8 + progress * 0.1).toString()}))`;
      }
    } else if (!isWideScreen) {
      // isMVSectionでなく、画面幅が768未満の場合の処理
      htmlImage.style.opacity = Math.max(0.3, 1.5 - progress).toString();
    } else {
      // isMVSectionでなく、画面幅が768以上の場合の処理
      // トランジションを追加
      htmlImage.style.transition = "opacity 1s ease";
      if (rect.top < windowHeight - 150 && rect.bottom > 150) {
        htmlImage.style.opacity = "1"; // 画面内に50px入ったら表示
      } else {
        htmlImage.style.opacity = "0"; // 画面外に出たら非表示
      }
    }
  }

  // if (text) {
  //   const textElement = text as HTMLElement;
  //   if (!isMVSection) {
  //     textElement.style.transform = `translateY(${Math.min(0, (progress - 0.25) * 100)}%)`;
  //   }
  // }
}

export { handleScroll };
